import { type Moment } from 'moment-timezone';

export const ENTRANCE_TIME_SLOT_MODE_EVENT = 'event';
export const ENTRANCE_TIME_SLOT_MODE_LIMITED = 'limited';
export type EntranceTimeSlotMode = typeof ENTRANCE_TIME_SLOT_MODE_EVENT | typeof ENTRANCE_TIME_SLOT_MODE_LIMITED;

export interface EntranceTimeSlotValue {
  mode: EntranceTimeSlotMode;
  validFrom: Moment | null;
  validFromTime: string;
  validUntil: Moment | null;
  validUntilTime: string;
}

export interface DrinksValue {
  enabled: boolean;
  quantity: string;
}

export interface LowStockThresholdValue {
  enabled: boolean;
  quantity: string;
}

export interface AdvancedSettingsValue {
  entranceTimeSlot: EntranceTimeSlotValue;
  drinks?: DrinksValue;
  lowStockThreshold?: LowStockThresholdValue;
}

export interface AdvancedSettingsErrors {
  entranceTimeSlotValidFrom?: string;
  entranceTimeSlotValidFromTime?: string;
  entranceTimeSlotValidUntil?: string;
  entranceTimeSlotValidUntilTime?: string;
  entranceTimeSlotRange?: string;
  drinksQuantity?: string;
  lowStockThresholdQuantity?: string;
}

export interface AdvancedSettingsSectionProps {
  value: AdvancedSettingsValue;
  onChange: (patch: Partial<AdvancedSettingsValue>) => void;
  open: boolean;
  onToggleOpen: () => void;
  disabled?: boolean;
  timezone: string;
  locale?: string;
  minValidFromDate?: Moment;
  minValidUntilDate?: Moment;
  maxEndDate?: Moment;
  isEventInThePast?: boolean;
  lockLowStockThreshold?: boolean;
  errors?: AdvancedSettingsErrors;
  dataTestId?: string;
}
